import { IPartnerDetail } from '@viabizzuno/models';
import { getLayout } from '@viabizzuno/models/server';
import { LayoutDefault } from '@viabizzuno/ui';
import { asEquatable, IStaticContext, PageProps } from '@websolutespa/bom-core';
import { getPage, getPageProps, getStaticPathsForSchema } from '@websolutespa/bom-mixer-models/server';
import { LazyLoader, OpenGraph, StructuredData } from '@websolutespa/bom-mixer-ui';

export default function PartnerDetail({ layout, page, params }: PageProps<IPartnerDetail>) {
  return (
    <>
      <LazyLoader components={page.components} />
      <StructuredData />
      <OpenGraph />
    </>
  );
}

PartnerDetail.Layout = LayoutDefault;

export async function getStaticProps(context: IStaticContext) {
  const id = asEquatable(context.params.id);
  const market = context.params.market;
  const locale = context.params.locale;
  const layout = await getLayout(market, locale);
  const page = await getPage<IPartnerDetail>('partner_detail', id, market, locale);

  if (!page) {
    return {
      notFound: true,
      revalidate: true,
    };
  }

  const props = await getPageProps({ ...context, layout, page });
  return {
    props,
    revalidate: 60 * 60 * 2, // revalidate
  };
}

export async function getStaticPaths() {
  const paths = await getStaticPathsForSchema('partner_detail');
  return {
    paths,
    fallback: 'blocking', // runs before initial render
    // fallback: true, // runs in the background
  };
}
